import axios from "axios";
import { API_BASE_URL } from "../creds";

class ServicesController {
  static async getServices(routerName) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${routerName}`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch ${routerName}`);
    }
  }

  static async getService(routerName, id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${routerName}/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch ${routerName} with id ${id}`);
    }
  }

  static async addService(routerName, payload) {
    try {
      const response = await axios.post(`${API_BASE_URL}/${routerName}/`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to add ${routerName}`);
    }
  }

  static async addFormService(routerName, payload) {
    try {
      const response = await axios.post(`${API_BASE_URL}/${routerName}/`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to add ${routerName}: ${error.message}`);
    }
  }

  static async updateService(routerName, id, payload) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${routerName}/${id}`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update ${routerName}`);
    }
  }

  static async updateFormService(routerName, id, payload) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${routerName}/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "json",
      });
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update ${routerName}: ${error.message}`);
    }
  }

  static async deleteService(routerName, id) {
    try {
      await axios.delete(`${API_BASE_URL}/${routerName}/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      throw new Error(`Failed to delete ${routerName}`);
    }
  }
}

export default ServicesController;